import { commonRequest } from '../../services/ApiCall';
import { Helpers } from '../../services/Helpers';

const url = (id, quickBook) => `${Helpers.URL()}/api/v2/admin/${quickBook ? 'quick-book/requests' : 'service-booking'}/${encodeURIComponent(id)}/instructions`;
export const InstructionService = {
  latest: (id, quickBook) => commonRequest('GET', url(id, quickBook), {}, Helpers.token(), null, {}, { inlineErrors: true }),
  update: (id, quickBook, payload) => commonRequest('PUT', url(id, quickBook), payload, Helpers.token(), null, {}, { inlineErrors: true }),
  history: (id, quickBook, instructionType, page) => commonRequest('GET', `${url(id, quickBook)}/history?${new URLSearchParams({ instructionType, page, limit: 20 })}`, {}, Helpers.token(), null, {}, { inlineErrors: true }),
};
export const instructionResponseOk = (response) => response?.status === 'success' || response?.success === 1 || response?.success === '1';
